import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { Typography } from '@material-ui/core';

import { formatMoeda } from '../../../utils';

const ProdutoField = (props) => {
  const record = useRecordContext(props);
  const valor = record
    ? record.record
      ? `${formatMoeda(record.record.verba_total)}`
      : '-'
    : '-';

  return <Typography variant="subtitle1">{valor}</Typography>;
};

export default ProdutoField;
